import { CommonModule } from '@angular/common'
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild, inject } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog'
import { MatSort, MatSortModule } from '@angular/material/sort'
import { MatTableDataSource, MatTableModule } from '@angular/material/table'
import { MatchedOffer } from '@tradecafe/types/core'
import { map } from 'lodash-es'
import { PipesModule } from 'src/shared/pipes/pipes.module'
import { getAbsolutePrice, getSign } from '../price-sign.utils'

export interface MatchedOfferBidHistoryOverlayOptions {
  matchedOffer: MatchedOffer
}

interface BidHistoryRow {
  created: number
  amount: number
  active: boolean
  currency: string
}

@Component({
  selector: 'tc-matched-offer-bid-history-overlay',
  templateUrl: './matched-offer-bid-history-overlay.component.html',
  styleUrls: ['./matched-offer-bid-history-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatSortModule,
    MatTableModule,
    PipesModule,
  ],
})
export class MatchedOfferBidHistoryOverlayComponent implements OnInit, AfterViewInit {
  private dialogData = inject<MatchedOfferBidHistoryOverlayOptions>(MAT_DIALOG_DATA)
  private dialogRef = inject<MatDialogRef<MatchedOfferBidHistoryOverlayComponent, void>>(MatDialogRef)
  private cdr = inject(ChangeDetectorRef)

  @ViewChild(MatSort) sort: MatSort

  matchedOffer: MatchedOffer
  isFormula = false
  displayColumns = ['created', 'amount', 'active']
  dataSource = new MatTableDataSource<BidHistoryRow>()

  ngOnInit(): void {
    this.matchedOffer = this.dialogData.matchedOffer
    this.isFormula = !!this.matchedOffer?.bid?.formula
    this.dataSource.data = map(this.matchedOffer?.bids, (bid): BidHistoryRow => ({
      created: bid.created,
      amount: bid.amount,
      active: bid.active,
      currency: this.matchedOffer?.bid?.currency,
    }))
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort
    this.cdr.detectChanges()
  }

  protected getSign = getSign
  protected getAbsolutePrice = getAbsolutePrice

  close(): void {
    this.dialogRef.close()
  }
}